import { Card, Grid, Stack, Typography, Button } from "@mui/material";
import InputControl from "../../../shared/components/InputControl";
import { Loader } from "../../../shared";
import { useStampCardsSettings } from "../hooks";

export const StampCardsSettings = () => {
  const { state, validator, handleChange, handleSave } =
    useStampCardsSettings();

  const { isLoading, isSaving, details } = state;

  return (
    <Card sx={{ p: "24px", mb: "24px" }}>
      {isLoading ? (
        <Loader />
      ) : (
        <Grid container spacing={3}>
          <Grid item xs={12} md={3}>
            <Typography variant="subtitle1" fontWeight={600}>
              How it works
            </Typography>
          </Grid>
          <Grid item xs={12} md={9}>
            <Stack width="100%" gap="12px">
              <InputControl
                type="textarea"
                rows={4}
                name="how_it_works"
                label="How it works"
                value={details.how_it_works}
                onChange={handleChange}
                required
                error={validator.current.message(
                  "How it works",
                  details.how_it_works,
                  "required",
                )}
                helperText={validator.current.message(
                  "How it works",
                  details.how_it_works,
                  "required",
                )}
              />
            </Stack>
          </Grid>

          <Grid item xs={12} md={3}>
            <Typography variant="subtitle1" fontWeight={600}>
              Terms & Conditions URL
            </Typography>
          </Grid>
          <Grid item xs={12} md={9}>
            <Stack width="100%" gap="12px">
              <InputControl
                name="terms_and_conditions_link"
                label="Terms & Conditions URL"
                value={details.terms_and_conditions_link}
                onChange={handleChange}
              />
            </Stack>
          </Grid>

          <Grid item xs={12}>
            <Stack direction="row" justifyContent="flex-end" mt={2}>
              <Button
                type="button"
                size="medium"
                variant="contained"
                onClick={handleSave}
                disabled={isSaving}
              >
                Save
              </Button>
            </Stack>
          </Grid>
        </Grid>
      )}
    </Card>
  );
};
